function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m444.972656 0h-288.960937c-9.648438 0-17.5 7.851562-17.5 17.5v191.859375l-91.492188-101.859375c-2.65625-2.957031-6.308593-4.703125-10.277343-4.914062-3.980469-.214844-7.785157 1.132812-10.742188 3.789062l-20.570312 18.476562c-6.105469 5.484376-6.609376 14.914063-1.125 21.019532l129.238281 143.875c1.410156 1.570312 3.101562 2.785156 4.96875 3.625v115.769531h-29.152344c-4.144531 0-7.5 3.359375-7.5 7.5s3.355469 7.5 7.5 7.5h206.765625c1.378906 0 2.5 1.121094 2.5 2.5v15.417969c0 22.257812 10.453125 42.121094 26.703125 54.9375h-265.746094c-30.296875 0-54.945312-24.644532-54.945312-54.941406v-15.414063c0-1.378906 1.121093-2.5 2.5-2.5h49.5625c4.140625 0 7.5-3.359375 7.5-7.5s-3.359375-7.5-7.5-7.5h-49.5625c-9.648438 0-17.5 7.851563-17.5 17.5v15.414063c0 38.566406 31.378906 69.941406 69.945312 69.941406h312.945313c38.566406 0 69.945312-31.375 69.945312-69.941406v-204.09375c0-4.140626-3.355468-7.5-7.5-7.5-4.144531 0-7.5 3.359374-7.5 7.5v204.09375c0 30.296874-24.648437 54.945312-54.945312 54.945312h-3.964844c-30.296875 0-54.941406-24.644531-54.941406-54.941406v-15.414063c0-9.652343-7.851563-17.5-17.5-17.5h-162.609375v-110.347656l21.398437 10.636719c1.699219.84375 3.519532 1.257812 5.324219 1.257812 2.875 0 5.707031-1.046875 7.957031-3.066406 3.660156-3.289062 4.921875-8.394531 3.214844-13.011719l-11.5-31.101562c.066406-.460938.117188-.921875.140625-1.390625.214844-3.96875-1.132813-7.785156-3.789063-10.742188l-22.746093-25.320312v-208.558594c0-1.378906 1.121093-2.5 2.5-2.5h288.960937c1.378906 0 2.5 1.121094 2.5 2.5v97.804688c0 4.144531 3.355469 7.5 7.5 7.5 4.144532 0 7.5-3.355469 7.5-7.5v-97.804688c0-9.648438-7.851562-17.5-17.5-17.5zm-409.035156 117.609375 8.90625 9.917969-20.394531 18.324218-8.910157-9.917968zm-1.46875 39.402344 4.621094-4.152344 110.152344 122.628906-4.617188 4.152344zm126.046875 128.515625 8.660156-7.78125 5.480469 14.808594zm-.113281-20.0625-110.152344-122.628906 4.617188-4.148438 110.152343 122.628906zm0 0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m454.972656 140.46875c-4.140625 0-7.5 3.355469-7.5 7.5v57.332031c0 4.144531 3.359375 7.5 7.5 7.5 4.144532 0 7.5-3.355469 7.5-7.5v-57.332031c0-4.144531-3.355468-7.5-7.5-7.5zm0 0"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m214.171875 150.605469c-14.148437 0-25.660156 11.511719-25.660156 25.664062 0 14.148438 11.511719 25.660157 25.660156 25.660157 14.152344 0 25.664063-11.511719 25.664063-25.660157 0-14.152343-11.511719-25.664062-25.664063-25.664062zm0 36.324219c-5.878906 0-10.660156-4.78125-10.660156-10.660157 0-5.878906 4.78125-10.664062 10.660156-10.664062s10.664063 4.785156 10.664063 10.664062c0 5.878907-4.785157 10.660157-10.664063 10.660157zm0 0"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m262.398438 185.378906h36.75c4.140624 0 7.5-3.359375 7.5-7.5s-3.359376-7.5-7.5-7.5h-36.75c-4.140626 0-7.5 3.359375-7.5 7.5s3.359374 7.5 7.5 7.5zm0 0"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m390.503906 188.355469h-128.105468c-4.140626 0-7.5 3.355469-7.5 7.5 0 4.140625 3.359374 7.5 7.5 7.5h128.105468c4.140625 0 7.5-3.359375 7.5-7.5 0-4.144531-3.359375-7.5-7.5-7.5zm0 0"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m262.4375 164.183594h.050781c4.140625-.027344 7.476563-3.40625 7.453125-7.546875-.027344-4.128907-3.382812-7.453125-7.5-7.453125-.015625 0-.03125 0-.050781 0h-.074219c-4.144531.023437-7.441406 3.402344-7.414062 7.546875.023437 4.125 3.414062 7.453125 7.535156 7.453125zm0 0"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "m214.171875 229.832031c-14.148437 0-25.660156 11.511719-25.660156 25.664063 0 14.148437 11.511719 25.660156 25.660156 25.660156 14.152344 0 25.664063-11.511719 25.664063-25.660156 0-14.152344-11.511719-25.664063-25.664063-25.664063zm0 36.324219c-5.878906 0-10.660156-4.78125-10.660156-10.664062 0-5.878907 4.78125-10.660157 10.660156-10.660157s10.664063 4.78125 10.664063 10.660157c0 5.882812-4.785157 10.664062-10.664063 10.664062zm0 0"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "m262.398438 264.605469h36.75c4.140624 0 7.5-3.359375 7.5-7.5s-3.359376-7.5-7.5-7.5h-36.75c-4.140626 0-7.5 3.359375-7.5 7.5s3.359374 7.5 7.5 7.5zm0 0"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "m390.503906 267.582031h-128.105468c-4.140626 0-7.5 3.355469-7.5 7.5 0 4.140625 3.359374 7.5 7.5 7.5h128.105468c4.140625 0 7.5-3.359375 7.5-7.5 0-4.144531-3.359375-7.5-7.5-7.5zm0 0"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "m262.4375 243.40625h.050781c4.140625-.023438 7.476563-3.402344 7.453125-7.546875-.027344-4.125-3.382812-7.453125-7.5-7.453125-.015625 0-.03125 0-.050781 0h-.074219c-4.144531.027344-7.441406 3.40625-7.414062 7.546875.023437 4.128906 3.414062 7.453125 7.535156 7.453125zm0 0"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "m214.171875 309.058594c-14.148437 0-25.660156 11.511718-25.660156 25.664062 0 14.148438 11.511719 25.660156 25.660156 25.660156 14.152344 0 25.664063-11.511718 25.664063-25.660156 0-14.152344-11.511719-25.664062-25.664063-25.664062zm0 36.324218c-5.878906 0-10.660156-4.78125-10.660156-10.660156s4.78125-10.664062 10.660156-10.664062 10.664063 4.785156 10.664063 10.664062-4.785157 10.660156-10.664063 10.660156zm0 0"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "m262.398438 343.832031h36.75c4.140624 0 7.5-3.359375 7.5-7.5s-3.359376-7.5-7.5-7.5h-36.75c-4.140626 0-7.5 3.359375-7.5 7.5s3.359374 7.5 7.5 7.5zm0 0"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "m262.398438 361.808594h128.105468c4.140625 0 7.5-3.359375 7.5-7.5 0-4.144532-3.359375-7.5-7.5-7.5h-128.105468c-4.140626 0-7.5 3.355468-7.5 7.5 0 4.140625 3.359374 7.5 7.5 7.5zm0 0"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "m262.4375 322.636719h.050781c4.140625-.027344 7.476563-3.40625 7.453125-7.546875-.027344-4.128906-3.382812-7.453125-7.5-7.453125-.015625 0-.03125 0-.050781 0h-.074219c-4.144531.023437-7.441406 3.402343-7.414062 7.546875.023437 4.125 3.414062 7.453125 7.535156 7.453125zm0 0"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "m409.230469 98.28125v-43.496094c0-4.144531-3.359375-7.5-7.5-7.5h-202.472657c-4.144531 0-7.5 3.355469-7.5 7.5v43.496094c0 4.144531 3.355469 7.5 7.5 7.5h202.472657c4.140625 0 7.5-3.355469 7.5-7.5zm-15-7.5h-187.472657v-28.496094h187.472657zm0 0"
});

var SvgPlan = function SvgPlan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: "511pt",
    viewBox: "-25 0 511 511.998",
    width: "511pt",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plan.7b6fcaa3.svg";
export { ForwardRef as ReactComponent };